// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "80cd50010cee368fa628d2a92b179b9b58cb84cb/static/css/" + chunkId + "." + {"200":"4f7b3521","729":"40937596","825":"f81e5cfb"}[chunkId] + ".chunk.css";
};